const papersDataEdexcelInternationalAlevel = {
  mathematics: [
    {
      year: '2023',
      papers: [
        {
          label: 'F1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm01-01-que-20230531.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm01-01-rms-20230817.pdf',
        },
        {
          label: 'F2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm02-01-que-20230609.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm02-01-rms-20230817.pdf',
        },
        {
          label: 'F3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm03-01-que-20230616.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wfm03-01-rms-20230817.pdf',
        },
        {
          label: 'M1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme01-01-que-20230517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme01-01-rms-20230817.pdf',
        },
        {
          label: 'M2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme02-01-que-20230526.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme02-01-rms-20230817.pdf',
        },
        {
          label: 'M3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme03-01-que-20230607.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wme03-01-rms-20230817.pdf',
        },
        {
          label: 'S1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst01-01-que-20230512.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst01-01-rms-20230817.pdf',
        },
        {
          label: 'S2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst02-01-que-20230524.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst02-01-rms-20230817.pdf',
        },
        {
          label: 'S3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst03-01-que-20230614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Mathematics/2018/Exam-materials/wst03-01-rms-20230817.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'F1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm01-01-que-20220524.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm01-01-rms-20220818.pdf',
        },
        {
          label: 'F2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm02-01-que-20220608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm02-01-rms-20220818.pdf',
        },
        {
          label: 'F3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm03-01-que-20220615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm03-01-rms-20220818.pdf',
        },
        {
          label: 'M1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wme01-01-que-20220511.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wme01-01-rms-20220818.pdf',
        },
        {
          label: 'M2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wme02-01-que-20220517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wme02-01-rms-20220818.pdf',
        },
        {
          label: 'M3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wme03-01-que-20220531.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wme03-01-rms-20220818.pdf',
        },
        {
          label: 'S1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst01-01-que-20220526.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst01-01-rms-20220818.pdf',
        },
        {
          label: 'S2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst02-01-que-20220601.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst02-01-rms-20220818.pdf',
        },
        {
          label: 'S3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst03-01-que-20220611.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst03-01-rms-20220818.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'F1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm01-01-que-20210430.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM01_01_rms_20210604.pdf',
        },
        {
          label: 'F2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM02_01_que_20210427.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM02_01_rms_20210604.pdf',
        },
        {
          label: 'F3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM03_01_que_20210507.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM03_01_rms_20210604.pdf',
        },
        {
          label: 'M1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME01_01_que_20210430.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME01_01_msc_20210517.pdf',
        },
        {
          label: 'M2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME02_01_que_20210422.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME02_01_rms_20210604.pdf',
        },
        {
          label: 'M3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME03_01_que_20210430.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME03_01_rms_20210604.pdf',
        },
        {
          label: 'S1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WST01_01_que_20210427.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WST01_01_rms_20210604.pdf',
        },
        {
          label: 'S2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WST02_01_que_20210430.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst02-01-rms-20210604.pdf',
        },
        {
          label: 'S3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst03-01-que-20210507.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst03-01-rms-20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'F1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM01_01_que_20201022.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm01-01-msc-202010113.pdf',
        },
        {
          label: 'F2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM02_01_que_20201010.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM02_01_msc_20210113.pdf',
        },
        {
          label: 'F3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wfm03-01-que-20201016.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WFM03_01_msc_202010113.pdf',
        },
        {
          label: 'M1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wme01-01-que-20201017.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME01_01_msc_20210113.pdf',
        },
        {
          label: 'M2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME02_01_que_20201021.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME02_01_msc_20210113.pdf',
        },
        {
          label: 'M3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WME03_01_que_20201014.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wme03-01-msc-20210113.pdf',
        },
        {
          label: 'S1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst01-01-que-20201023.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst01-01-msc-20210113.pdf',
        },
        {
          label: 'S2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WST02_01_que_20201015.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WST02_01_msc_20210113.pdf',
        },
        {
          label: 'S3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/wst03-01-que-20201013.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Mathematics/2018/Exam-materials/WST03_01_msc_20210113.pdf',
        },
      ],
    },
  ],
  biology: [
    {
      year: '2023',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi11-01-que-20230509.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi11-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi12-01-que-20230520.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi12-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi13-01-que-20230525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi13-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi14-01-que-20230602.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi14-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi15-01-que-20230606.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi15-01-rms-20230817.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi16-01-que-20230617.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-Advanced-Level/Biology/2018/Exam-materials/wbi16-01-rms-20230817.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi11-01-que-20220510.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi11-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi12-01-que-20220518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi12-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi13-01-que-20220526.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi13-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi14-01-que-20220528.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi14-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi15-01-que-20220609.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi15-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi16-01-que-20220617.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/wbi16-01-rms-20220818.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI11_01_que_20210421.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI11_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI12_01_que_20210505.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI12_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI13_01_que_20210506.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI13_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI14_01_que_20210419.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI14_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI14_01_que_20210419.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI15_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI16_01_que_20210505.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI16_01_rms_20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI11_01_que_20201006.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI11_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI12_01_que_20201009.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI12_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI13_01_que_20201014.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI13_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI14_01_que_20201017.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI14_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI15_01_que_20201022.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI15_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI16_01_que_20201027.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Biology/2018/Exam-materials/WBI16_01_msc_20210113.pdf',
        },
      ],
    },
  ],
  chemistry: [
    {
      year: '2023',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch11-01-que-20230112.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch11-01-rms-20230302.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch12-01-que-20230117.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch12-01-rms-20230302.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch13-01-que-20230120.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch13-01-rms-20230302.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch14-01-que-20230110.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch14-01-rms-20230302.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch15-01-que-20230113.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch15-01-rms-20230302.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch16-01-que-20230119.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch16-01-rms-20230302.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch11-01-que-20220511.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch11-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch12-01-que-20220519.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch12-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch13-01-que-20220524.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch13-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch14-01-que-20220602.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch14-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch15-01-que-20220610.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch15-01-rms-20220818.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch16-01-que-20220615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/wch16-01-rms-20220818.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH11_01_que_20210420.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH11_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH12_01_que_20210426.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH12_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH13_01_que_20210430.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH13_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH14_01_que_20210421.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH14_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH15_01_que_20210428.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH15_01_rms_20210604.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH16_01_que_20210505.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH16_01_rms_20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Unit 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH11_01_que_20201007.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH11_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH12_01_que_20201010.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH12_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH13_01_que_20201015.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH13_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 4',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH14_01_que_20201020.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH14_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 5',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH15_01_que_20201023.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH15_01_msc_20210113.pdf',
        },
        {
          label: 'Unit 6',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH16_01_que_20201028.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20Advanced%20Level/Chemistry/2018/Exam-materials/WCH16_01_msc_20210113.pdf',
        },
      ],
    },
  ],
  physics: [
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9ph0-01-que-20230525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9ph0-01-rms-20230817.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9ph0-02-que-20230610.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9ph0-02-rms-20230817.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9ph0-03-que-20230616.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9ph0-03-rms-20230817.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9ph0-01-que-20220527.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9ph0-01-rms-20220818.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9ph0-02-que-20220611.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9ph0-02-rms-20220818.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9ph0-03-que-20220617.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9ph0-03-rms-20220818.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_01_que_20211009.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_01_rms_20211216.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_02_que_20211015.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_02_rms_20211216.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_03_que_20211021.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_03_rms_20211216.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_01_que_20201010.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_01_msc_20201217.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_02_que_20201016.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_02_msc_20201217.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_03_que_20201022.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_03_msc_20201217.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_01_que_20190521.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_01_rms_20190815.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_02_que_20190525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_02_rms_20190815.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_03_que_20190604.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Physics/2015/Exam-materials/9PH0_03_rms_20190815.pdf',
        },
      ],
    },
  ],
  economics: [
    {
      year: '2023',
      papers: [
        {
          label: 'Economics A: Paper 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9ec0-01-que-20230519.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9ec0-01-rms-20230817.pdf',
        },
        {
          label: 'Economics A: Paper 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9ec0-02-que-20230523.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9ec0-02-rms-20230817.pdf',
        },
        {
          label: 'Economics A: Paper 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9ec0-03-que-20230606.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9ec0-03-rms-20230817.pdf',
        },
        {
          label: 'Economics B: Paper 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9eb0-01-que-20230519.pdf',
          marking: '',
        },
        {
          label: 'Economics B: Paper 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9eb0-02-que-20230523.pdf',
          marking: '',
        },
        {
          label: 'Economics B: Paper 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9eb0-03-que-20230606.pdf',
          marking: '',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Economics A: Paper 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9ec0-01-que-20220524.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9ec0-01-rms-20220818.pdf',
        },
        {
          label: 'Economics A: Paper 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9ec0-02-que-20220607.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9ec0-02-rms-20220818.pdf',
        },
        {
          label: 'Economics A: Paper 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9ec0-03-que-20220614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9ec0-03-rms-20220818.pdf',
        },
        {
          label: 'Economics B: Paper 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9eb0-01-que-20220524.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9eb0-01-rms-20220818.pdf',
        },
        {
          label: 'Economics B: Paper 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9eb0-02-que-20220607.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9eb0-02-rms-20220818.pdf',
        },
        {
          label: 'Economics B: Paper 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9eb0-03-que-20220614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9eb0-03-rms-20220818.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Economics A: Paper 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_01_que_20211005.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_01_rms_20211216.pdf',
        },
        {
          label: 'Economics A: Paper 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_02_que_20211009.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_02_rms_20211216.pdf',
        },
        {
          label: 'Economics A: Paper 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_03_que_20211015.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_03_rms_20211216.pdf',
        },
        {
          label: 'Economics B: Paper 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_01_que_20211005.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_01_rms_20211216.pdf',
        },
        {
          label: 'Economics B: Paper 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_02_que_20211009.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_02_rms_20211216.pdf',
        },
        {
          label: 'Economics B: Paper 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9eb0-03-que-20211015.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_03_rms_20211216.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Economics A: Paper 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_01_que_20201006.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0-01-msc-20201217.pdf',
        },
        {
          label: 'Economics A: Paper 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_02_que_20201010.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_02_msc_202001217.pdf',
        },
        {
          label: 'Economics A: Paper 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_03_que_20201016.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_03_msc_202001217.pdf',
        },
        {
          label: 'Economics B: Paper 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_01_que_20201006.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_01_msc_20201217.pdf',
        },
        {
          label: 'Economics B: Paper 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_02_que_20201010.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_02_msc_20201217.pdf',
        },
        {
          label: 'Economics B: Paper 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_03_que_20201016.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_03_msc_20201217.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Economics A: Paper 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_01_que_20190521.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_01_rms_20190815.pdf',
        },
        {
          label: 'Economics A: Paper 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_02_que_20190524.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_02_rms_20190815.pdf',
        },
        {
          label: 'Economics A: Paper 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_03_que_20190605.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EC0_03_rms_20190815.pdf',
        },
        {
          label: 'Economics B: Paper 1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_01_que_20190521.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_01_rms_20190815.pdf',
        },
        {
          label: 'Economics B: Paper 2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_02_que_20190524.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_02_rms_20190815.pdf',
        },
        {
          label: 'Economics B: Paper 3',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_03_que_20190605.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/A-Level/Economics/2015/Exam-materials/9EB0_03_rms_20190815.pdf',
        },
      ],
    },
  ],
};

export default papersDataEdexcelInternationalAlevel;
